import { HTMLAttributes } from "react";

export const CardContent = ({
  children,
  className = "",
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={`p-4 pb-6 flex flex-col gap-1 flex-1 ${className}`.trim()}
    {...props}
  >
    {children}
  </div>
);